<template>
  <z-popup v-model="showPanel" position="bottom" @close="close">
    <div class="panel">
      <z-icon class="close" class-prefix="zziconfont-6" name="close" @click="close" />
      <div v-if="title" class="title">
        {{ title }}
      </div>
      <div v-if="!isDistory" class="content">
        <slot></slot>
      </div>
      <z-button-group v-if="showBottomBtn">
        <z-button size="large" type="primary" @click.stop="close">我知道了</z-button>
      </z-button-group>
    </div>
  </z-popup>
</template>
<script lang="js">
  import Vue from 'vue'
  import { Icon, Popup, Button, ButtonGroup } from '@zz-common/zz-ui'
  Vue.use(Icon, { optimizeClickArea: true }).use(Popup).use(Button).use(ButtonGroup)
  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
      showBottomBtn: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        showPanel: false,
        isDistory: false,
      }
    },
    methods: {
      show() {
        this.showPanel = true
      },
      close() {
        this.showPanel = false
        // 使用v-if手动销毁组件，以完成重置组件的目的。
        this.isDistory = true
        this.$nextTick(() => {
          this.isDistory = false
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .panel {
    position: relative;
    border-top: 1px solid white;
    overflow-y: scroll;

    .close {
      color: #b8b8b8;
      position: absolute;
      top: 55px;
      right: 32px;
      width: 24px;
      height: 24px;
      font-size: 24px;
      z-index: 1;
    }

    .title {
      height: 80px;
      margin: 24px auto;
      text-align: center;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #111111;
      line-height: 80px;
      position: relative;
    }

    .content {
      max-height: 80vh;
      overflow-y: scroll;
      box-sizing: border-box;
    }
  }
</style>
